import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 3v7.586l3.707 3.707A1 1 0 0 1 14 15v6h6V3zM4 15.414V21h3v-3a1 1 0 1 1 2 0v3h3v-5.586l-4-4zm12-1.404V14a1 1 0 1 1 2 0v.01a1 1 0 1 1-2 0m-4-4V10a1 1 0 1 1 2 0v.01a1 1 0 1 1-2 0m4 0V10a1 1 0 1 1 2 0v.01a1 1 0 1 1-2 0m-4-4V6a1 1 0 1 1 2 0v.01a1 1 0 1 1-2 0m4 0V6a1 1 0 1 1 2 0v.01a1 1 0 1 1-2 0M22 22a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-7l.005-.099a1 1 0 0 1 .288-.608l5-5 .076-.068A1 1 0 0 1 8 9V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
    }, null, -1)
  ]))]))
}
export default { render: render }